/**
 * Localstorage integration into Vue
 */
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
/**
 * Currently localstorage being used for approvals
 * 
 * When an approver clicks approve/reject link from an email and navigates to the app,
 * if the user isn't already logged in, the approval info is storage in localstorage.
 * Once the user logs in the app detects information for approval in localstorage it automatically
 * routes to approval link and deletes information stored in localstorage
 * 
 * if already logged in then localstorage is not used and app direclty routes to approval/rejection link
 */
Vue.use(VueLocalStorage, {
    name: 'approvals', 
    bind: true
})
